import { render, staticRenderFns } from "./RegistrationFormPage.vue?vue&type=template&id=ea7087ce&scoped=true"
import script from "./RegistrationFormPage.vue?vue&type=script&lang=ts"
export * from "./RegistrationFormPage.vue?vue&type=script&lang=ts"
import style0 from "./RegistrationFormPage.vue?vue&type=style&index=0&id=ea7087ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea7087ce",
  null
  
)

export default component.exports